import { createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut, sendPasswordResetEmail, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { auth, isFirebaseConfigured } from './app';

function requireAuth() {
  if (!isFirebaseConfigured || !auth) throw new Error('Paste your Firebase config in src/firebase/firebase-config.js before using authentication.');
  return auth;
}
export async function signUpWithEmail(email, password) { await setPersistence(requireAuth(), browserLocalPersistence); return createUserWithEmailAndPassword(requireAuth(), email, password); }
export async function loginWithEmail(email, password) { await setPersistence(requireAuth(), browserLocalPersistence); return signInWithEmailAndPassword(requireAuth(), email, password); }
export function logout() { return signOut(requireAuth()); }
export function resetPassword(email) { return sendPasswordResetEmail(requireAuth(), email); }
